module.exports = __webpack_public_path__ + "src/assets/img/selector-star.79403e2f.svg";